import type { CSSProperties, PropsWithChildren, ReactNode } from 'react';

/**
 * 玻璃面板卡片。
 *
 * <Panel title="全国健康度" extra={<Badge tone="run">实时</Badge>}>内容</Panel>
 */
export interface PanelProps {
  title?: ReactNode;
  extra?: ReactNode;
  className?: string;
  style?: CSSProperties;
  /** 无内边距（适合放表格 / 地图等自管理布局） */
  flush?: boolean;
}

export default function Panel({
  title,
  extra,
  className,
  style,
  flush,
  children,
}: PropsWithChildren<PanelProps>) {
  const hasHead = title !== undefined || extra !== undefined;
  return (
    <section className={['panel', className].filter(Boolean).join(' ')} style={style}>
      {hasHead && (
        <header className="panel__head">
          {title !== undefined && <h3 className="panel__title">{title}</h3>}
          {extra !== undefined && <div className="panel__extra">{extra}</div>}
        </header>
      )}
      <div className="panel__body" style={flush ? { padding: 0 } : undefined}>
        {children}
      </div>
    </section>
  );
}
